import * as React from "react"
const FacebookIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} {...props}>
    <g data-name="Group 174">
      <path
        fill="#0e5492"
        d="M25 12.577a12.5 12.5 0 1 0-14.454 12.426v-8.791H7.374v-3.634h3.175V9.803c0-3.151 1.867-4.892 4.721-4.892a19.118 19.118 0 0 1 2.8.245v3.096h-1.578a1.813 1.813 0 0 0-2.036 1.965v2.359h3.465l-.553 3.634h-2.914v8.793A12.556 12.556 0 0 0 25 12.577Z"
        data-name="Path 372"
      />
    </g>
  </svg>
)
export default FacebookIcon;
